{
    "up.common.cancel": "Отмена",
    "up.common.confirm": "Подтвердить",
    "up.common.start": "Начало",
    "up.common.end": "Конец",
    "up.common.stop": "Стоп",
    "up.common.copy": "Копировать",
    "up.common.none": "Нет",
    "up.common.tip": "Подсказка",
    "up.common.success": "Успех",
    "up.common.fail": "Ошибка",
    "up.common.close": "Закрыть",
    "up.common.preview": "Предпросмотр",
    "up.common.re-select": "Выбрать снова",
    "up.common.rotate": "Повернуть",
    "up.common.pleaseChoose": "Пожалуйста, выберите",
    "up.common.loading": "Загрузка",
    "up.common.loading2": "Загружается",
    "up.common.inOperation": "В процессе",
    "up.common.settings": "Настройки",
    "up.common.retry": "Повторить",
    "up.common.search": "Поиск",
    "up.common.more": "Больше",
    "up.common.video": "Видео",
    "up.common.file": "Файл",
    "up.week.one": "Пн",
    "up.week.two": "Вт",
    "up.week.three": "Ср",
    "up.week.four": "Чт",
    "up.week.five": "Пт",
    "up.week.six": "Сб",
    "up.week.seven": "Вс",
    "up.barcode.error": "Ошибка генерации штрихкода",
    "up.calendar.chooseDates": "Выбор даты",
    "up.calendar.disabled": "Эта дата отключена",
    "up.calendar.daysExceed": "Количество выбранных дней не может превышать {days} дней",
    "up.cityLocate.locateCity": "Определение города",
    "up.cityLocate.fail": "Ошибка определения местоположения, нажмите для повтора.",
    "up.cityLocate.locating": "Определение местоположения",
    "up.code.send": "Получить код подтверждения",
    "up.code.resendAfter": "Повторная отправка через X секунд",
    "up.code.resend": "Отправить снова",
    "up.cropper.emptyWidhtOrHeight": "Ширина или высота области обрезки не задана",
    "up.empty.car": "Корзина пуста",
    "up.empty.page": "Страница не существует",
    "up.empty.search": "Нет результатов поиска",
    "up.empty.address": "Нет адреса доставки",
    "up.empty.wifi": "Нет Wi-Fi",
    "up.empty.order": "Заказы отсутствуют",
    "up.empty.coupon": "Нет купонов",
    "up.empty.favor": "Нет избранного",
    "up.empty.permission": "Нет разрешения",
    "up.empty.history": "Нет истории",
    "up.empty.news": "Нет новостей",
    "up.empty.message": "Список сообщений пуст",
    "up.empty.list": "Список пуст",
    "up.empty.data": "Нет данных",
    "up.empty.comment": "Нет комментариев",
    "up.link.copyed": "Ссылка скопирована, откройте в браузере",
    "up.loadmoe.loadmore": "Загрузить еще",
    "up.loadmoe.nomore": "Больше нет данных",
    "up.noNetwork.text": "Ой, потеряно сетевое соединение",
    "up.noNetwork.pleaseCheck": "Проверьте сеть или перейдите к",
    "up.noNetwork.connect": "Сеть подключена",
    "up.noNetwork.disconnect": "Нет сетевого подключения",
    "up.pagination.previous": "Предыдущая страница",
    "up.pagination.next": "Следующая страница",
    "up.pullRefresh.pull": "Потяните вниз для обновления",
    "up.pullRefresh.release": "Отпустите для обновления",
    "up.pullRefresh.refreshing": "Обновление",
    "up.readMore.expand": "Развернуть для полного чтения",
    "up.readMore.fold": "Свернуть",
    "up.search.placeholder": "Введите ключевое слово",
    "up.signature.penSize": "Размер штриха",
    "up.signature.penColor": "Цвет штриха",
    "up.upload.sizeExceed": "Превышен лимит размера",
    "up.upload.uploading": "Загрузка",
    "up.upload.previewImageFail": "Ошибка предпросмотра изображения",
    "up.upload.previewVideoFail": "Ошибка предпросмотра видео",
    "up.goodsSku.stock": "Запас",
    "up.goodsSku.price": "Цена",
    "up.goodsSku.amount": "Штук",
    "up.goodsSku.choosed": "Выбрано",
    "up.goodsSku.buyAmount": "Количество"
}
